'use client';

import { useAtomValue } from 'jotai';
import Link from 'next/link';

import { utmValuesFromVehicle } from '@core/Atoms/CarFinanceAd/UtmValuesFromVehicle.atom';
import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import Button from '@gds/Button/Button';
import { generateCtaClickedTracking } from '@tracking/CtaClicked.tracking';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import styles from './CarFinance.module.css';

export const CarFinanceAd = ({ includeVehicleDetails = false }) => {
  const userId = useAtomValue(userIdAtom);
  const searchParams = useAtomValue(searchParamsAtom);
  const formState = useAtomValue(formStateAtom);
  const utmValues = useAtomValue(utmValuesFromVehicle);

  let carmoneyUrl: string;

  if (includeVehicleDetails) {
    const queryString = Object.entries(utmValues)
      .map(([key, value]) => value && `${key}=${encodeURIComponent(value)}`)
      .join('&');
    carmoneyUrl = `https://raccars.carmoney.co.uk/car-finance-calculator?utm_source=carsrac&utm_medium=display&utm_content=vdl-ban&${queryString}`;
  } else {
    carmoneyUrl =
      'https://raccars.carmoney.co.uk/car-finance-calculator?utm_source=carsrac&utm_medium=display&utm_content=vdl-ban&utm_campaign=https://raccars.carmoney.co.uk&utm_term=carsrac';
  }

  const handleClick = () => {
    const { event, context } = generateCtaClickedTracking({
      searchParams,
      userId,
      formState,
      ctaType: 'button',
      ctaWording: 'Finance this car',
      ctaUrl: carmoneyUrl,
    });

    trackCustomEvent({ event, context });
  };

  return (
    <div className={styles.carFinanceAd}>
      <Button
        Component={Link}
        href={carmoneyUrl}
        variant="link"
        target="_blank"
        onClick={handleClick}
      >
        <img loading="lazy" src="/img/carmoney-widget.png" alt="CarMoney Widget" />
      </Button>
    </div>
  );
};
